import {BaseContainerModel} from '../base-container.model';
import { bl_fi_mst_branch_default_settlement_method_hdr_RowClass } from '../../dbschema/bl_fi_mst_branch_default_settlement_method_hdr.model';

export class BranchDefaultSettlementMethodHdrContainerModel extends BaseContainerModel {
  bl_fi_mst_branch_default_settlement_method_hdr: bl_fi_mst_branch_default_settlement_method_hdr_RowClass = new bl_fi_mst_branch_default_settlement_method_hdr_RowClass();
}